const STORAGE_KEY = 'dorel_registration_state';

// Recover State On Load
document.addEventListener('DOMContentLoaded', () => {
    loadFormState();

    // Listen to changes to save state iteratively
    const form = document.getElementById('registrationForm');
    if (form) {
        form.addEventListener('input', saveFormState);
        form.addEventListener('change', saveFormState);
    }

    // Terms checkbox logic:
    const termsCb = document.getElementById('terms');
    if (termsCb) {
        termsCb.addEventListener('click', (e) => {
            if (termsCb.checked) {
                e.preventDefault(); // Prevent checking until modal accepted
                openTerms(); // Defined in main.js
            }
        });
    }
});

// Save to localStorage
function saveFormState() {
    const form = document.getElementById('registrationForm');
    if (!form) return;

    const formData = new FormData(form);
    const state = Object.fromEntries(formData.entries());

    // Also capture checkbox states explicitly if unchecked
    form.querySelectorAll('input[type="checkbox"]').forEach(cb => {
        state[cb.name] = cb.checked;
    });

    localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
}

// Load from localStorage
function loadFormState() {
    const savedState = localStorage.getItem(STORAGE_KEY);
    if (!savedState) return;

    try {
        const state = JSON.parse(savedState);
        const form = document.getElementById('registrationForm');

        if (!form) return;

        Object.keys(state).forEach(key => {
            const field = form.elements[key];
            if (field) {
                // Handle RadioNodeList vs Single Field
                if (field instanceof RadioNodeList) {
                    field.value = state[key];
                    // Trigger change manually if needed for side-effects (e.g., gift radio UI)
                    field.forEach(f => {
                        if (f.checked) f.dispatchEvent(new Event('change', { bubbles: true }));
                    });
                } else if (field.type === 'checkbox') {
                    field.checked = !!state[key];
                } else {
                    field.value = state[key];
                }
            }
        });
    } catch (e) {
    }
}

function clearFormState() {
    localStorage.removeItem(STORAGE_KEY);
}
